<template>
  <div>
    <!-- Tabla con la lista de dispositivos-->
    <div>
      <vue-good-table id="measuresTable" mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
        :columns="columns" :rows="rows" ref="sensorMeasureData" :search-options="{
          skipDiacritics: true,
          placeholder: 'Buscar en la tabla',
        }" :pagination-options="{
          enabled: true,
          nextLabel: '',
          prevLabel: '',
          rowsPerPageLabel: 'Filas por pagina',
          ofLabel: 'de',
          pageLabel: 'pagina', // for 'pages' mode
          allLabel: 'Todas',
        }" :sort-options="{
          enabled: true,
          initialSortBy: { field: 'raw_ts', type: 'desc' },
        }" :isLoading.sync="isLoading">
        <template slot="loadingContent">
          <table-loading />
        </template>
        <template slot="emptystate">
          <table-empty-state />
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
// MIRAR EN https://xaksis.github.io/vue-good-table/guide/
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import DataService from "@/services/DataService";
import SensorService from "@/services/SensorService";
import Constants from "@/Constants";
import TableLoading from "@/components/common/TableLoading";
import TableEmptyState from "@/components/common/TableEmptyState";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "measures-list",
  data() {
    return {
      idsensor: null,
      totalRecords: 0,
      currentType: null,
      customColumnNames: [],
      columns: [],
      rows: [],
      pdfHeaders: [],
      exportRows: [],
      serverParams: {
        columnFilters: {},
        sort: {
          field: "raw_ts",
          type: "desc",
        },
        page: 1,
        perPage: 10,
      },
      isLoading: false,
    };
  },

  components: {
    VueGoodTable,
    "table-loading": TableLoading,
    "table-empty-state": TableEmptyState,
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    async onSortChange(params) {
      //onSortChange executes before retrieveDataFromSensor (which prepares the metadata neccesary), so it have to wait
      if (this.columns.length && this.columns.length > 0) {
        this.updateParams({
          page: 1,
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
        this.loadItems();
      }
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    // load items is what brings back the rows from server
    async loadItems() {
      this.isLoading = true;
      await DataService.getAllData(this.idsensor, this.currentType._id, this.serverParams)
        .then((filteredData) => {
          let data = filteredData.data;
          this.totalRecords = data.totalRecords;
          this.populateRows(this.currentType._id, data.data, false);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error getting filtered data (SensorMeasures.vue :: loadItems)");
          console.log(err);
        });
    },

    async retrieveDataFromSensor(idsensor) {
      try {
        // Preparing sensor type and columns
        this.rows = [];
        this.customColumnNames = [];
        this.idsensor = idsensor;

        await SensorService.getTypeFromSensorId(this.idsensor)
          .then(async (resSensorType) => {
            this.currentType = resSensorType.data;
            this.columns = eval("(" + this.currentType.columns + ")");

            // GET CUSTOM COLUMN NAMES
            // Returns string array with custom column names
            await SensorService.getCustomColumnNames(this.idsensor)
              .then(async (names) => {
                this.customColumnNames = names.data;

                if (this.customColumnNames.length && this.customColumnNames.length > 0) {
                  // El comienzo está en uno porque se envía un null de más del front al back en custom column names
                  for (let i = 0; i < this.customColumnNames.length; i++) {
                    if (this.customColumnNames[i] && this.columns[i + 2]) {
                      this.columns[i + 2].label = this.customColumnNames[i];
                    }
                  }
                }

                await SensorService.getCustomColumnHide(this.idsensor)
                  .then(async (hideFlags) => {
                    let customHide = hideFlags.data;

                    for (let i = 0; i < this.columns.length; i++) {
                      if (i > 1) {
                        if (customHide && customHide[i - 2] === true) {
                          this.columns[i].hidden = true;
                        } else {
                          this.columns[i].hidden = false;
                        }
                      }
                    }
                  })
                  .catch((err) => {
                    console.log("Error recuperando las banderas de columnas escondidas");
                    console.log(err);
                  });

                this.isLoading = true;

                await DataService.getAllData(
                  this.idsensor,
                  this.currentType._id,
                  this.serverParams
                )
                  .then((filteredData) => {
                    let dataResponse = filteredData.data;
                    this.totalRecords = dataResponse.totalRecords;
                    this.populateRows(this.currentType._id, dataResponse.data, false);
                    this.isLoading = false;
                  })
                  .catch((err) => {
                    console.log("Error recuperando medidas filtradas");
                    console.log(err);
                  });
              })
              .catch((err) => {
                console.log("Error retrieving custom column names");
                console.log(err);
              });
          })
          .catch((err) => {
            console.log("Error retrieving type from sensor id");
            console.log(err);
          });
      } catch (error) {
        this.isLoading = false;
        console.error("ERROR: SensorMeasure.vue - retrieveDataFromSensor");
        console.error(error);
      }
    },

    async exportCSV() {
      this.serverParams = {
        csvoptions: { format: "blob", csvcolums: this.columns },
      };
      // Get all data and sort it into rows
      await DataService.getAllData(this.idsensor, this.currentType._id, this.serverParams)
        .then(async (allData) => {
          var data = new Blob([allData.data], { type: "text/csv" });
          var url = window.URL.createObjectURL(data);

          var link = document.createElement("a");
          var filename = allData.headers["content-disposition"]
            .split("filename=")[1]
            .split(";")[0];
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          document.body.appendChild(link); // Required for FF

          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log("Error retrieving all data for csv export");
          console.log(err);
        });
    },

    async exportPDF(sensorId) {
      this.pdfHeaders = [];
      let currentSensor;

      await SensorService.get(sensorId)
        .then((response) => {
          currentSensor = response.data;
        })
        .catch((err) => {
          console.log("Error retrieving sensor for exportPDF");
          console.log(err);
        });

      for (var i = 0; i < this.columns.length; i += 1) {
        this.pdfHeaders.push({
          header: this.columns[i].label,
          datakey: this.columns[i].field,
        });
      }

      await DataService.getAllData(this.idsensor, this.currentType._id, {})
        .then(async (allData) => {
          await this.populateRows(this.currentType._id, allData.data, true);

          //measuresComp
          let doc = new jsPDF();
          let doclogo = require("@/assets/pdf/atlantic-copper/logo_acs.png");
          doc.addImage(doclogo, 20, 30, 80, 20);
          doc.setFontSize(13);
          doc.text(120, 20, "# ID: " + currentSensor._id);

          doc.setFontSize(10);
          doc.text(
            120,
            32,
            "Fecha informe: " +
            this.$moment(String(new Date())).local().format("DD/MM/YYYY HH:mm:ss")
          );
          doc.text(120, 38, "Descripcion: " + currentSensor.description);
          doc.text(120, 44, "Tipo de sensor: " + currentSensor.type.alias);
          doc.text(
            120,
            50,
            "Nodo asociado: " +
            currentSensor.device.alias +
            " (" +
            currentSensor.device.uuid +
            ")"
          );

          doc.line(20, 60, 200, 60); // horizontal line*/

          //Tablas
          doc.autoTable({
            theme: "striped",
            startX: 20,
            startY: 70,
            tableWidth: "auto",
            columnStyles: { text: { cellWidth: "auto" } },
            columns: this.pdfHeaders,
          });

          doc.autoTable({
            theme: "striped",
            startX: 20,
            startY: 80,
            tableWidth: "auto",
            columnStyles: { text: { cellWidth: "auto" } },
            body: this.exportRows,
          });

          doc.save(currentSensor.description + ".pdf");
        })
        .catch((err) => {
          console.log("Error retrieven all data for pdf export");
          console.log(err);
        });
    },

    populateRows(id_sensor_type, data, exportData) {
      if (exportData) {
        this.exportRows = [];
      } else {
        this.rows = [];
      }

      for (let i = 0; i < data.length; i++) {
        let d = data[i];

        //Create struct before insert it
        let newData = null;

        //Fill the struct by sensor_type
        switch (id_sensor_type.toString()) {
          // ID del acelerómetro BMA-400
          case Constants.ID_SENSOR_TYPES.BMA400.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              accelx: d.data.accelx || d.data.accelx == 0 ? d.data.accelx : " - ",
              accely: d.data.accely || d.data.accely == 0 ? d.data.accely : " - ",
              accelz: d.data.accelz || d.data.accelz == 0 ? d.data.accelz : " - ",
              //golpex: d.data.golpex ? ((d.data.golpex != 0) ? "Sí" : "No") : " - ",
              //golpey: d.data.golpey ? ((d.data.golpey != 0) ? "Sí" : "No") : " - ",
              golpez:
                d.data.golpez || d.data.golpez == 0
                  ? d.data.golpez != 0
                    ? "Sí"
                    : "No"
                  : " - ",
              angx: d.data.angx || d.data.angx == 0 ? d.data.angx : " - ",
              angy: d.data.angy || d.data.angy == 0 ? d.data.angy : " - ",
              angz: d.data.angz || d.data.angz == 0 ? d.data.angz : " - ",
              caida:
                d.data.caida || d.data.caida == 0
                  ? d.data.caida != 0
                    ? "Sí"
                    : "No"
                  : " - ",
            };
            break;
          // ID del acelerómetro ADXL355
          case Constants.ID_SENSOR_TYPES.ADXL355.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              accelx: d.data.accelx || d.data.accelx == 0 ? d.data.accelx : " - ",
              accely: d.data.accely || d.data.accely == 0 ? d.data.accely : " - ",
              accelz: d.data.accelz || d.data.accelz == 0 ? d.data.accelz : " - ",
              //golpex: d.data.golpex ? ((d.data.golpex != 0) ? "Sí" : "No") : " - ",
              //golpey: d.data.golpey ? ((d.data.golpey != 0) ? "Sí" : "No") : " - ",
              golpez:
                d.data.golpez || d.data.golpez == 0
                  ? d.data.golpez != 0
                    ? "Sí"
                    : "No"
                  : " - ",
              angx: d.data.angx || d.data.angx == 0 ? d.data.angx : " - ",
              angy: d.data.angy || d.data.angy == 0 ? d.data.angy : " - ",
              angz: d.data.angz || d.data.angz == 0 ? d.data.angz : " - ",
              caida:
                d.data.caida || d.data.caida == 0
                  ? d.data.caida != 0
                    ? "Sí"
                    : "No"
                  : " - ",
            };
            break;
          // Temperatura I2C
          case Constants.ID_SENSOR_TYPES.TEMPI2C.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
              humedad: d.data.humedad || d.data.humedad == 0 ? d.data.humedad : " - ",
            };
            break;
          // Temperatura SHT20
          case Constants.ID_SENSOR_TYPES.TEMPSHT20.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
              humedad: d.data.humedad || d.data.humedad == 0 ? d.data.humedad : " - ",
            };
            break;
          // Caudal REED
          case Constants.ID_SENSOR_TYPES.FLOWREED.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              caudal: d.data.caudal || d.data.caudal == 0 ? d.data.caudal : " - ",
              incremento:
                d.data.incremento || d.data.incremento == 0 ? d.data.incremento : " - ",
            };
            break;
          // Caudal Hidrojet
          case Constants.ID_SENSOR_TYPES.FLOWHIDROJET.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              caudal: d.data.caudal || d.data.caudal == 0 ? d.data.caudal : " - ",
              incremento:
                d.data.incremento || d.data.incremento == 0 ? d.data.incremento : " - ",
            };
            break;
          // Temperatura analógica
          case Constants.ID_SENSOR_TYPES.TEMPANALOG.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura / 10
                  : " - ",
            };
            break;
          // Tensión ADC
          case Constants.ID_SENSOR_TYPES.TENSIONADC.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              alimentacion:
                d.data.alimentacion || d.data.alimentacion == 0
                  ? d.data.alimentacion
                  : " - ",
              canal1: d.data.canal1 || d.data.canal1 == 0 ? d.data.canal1 : " - ",
              canal2: d.data.canal2 || d.data.canal2 == 0 ? d.data.canal2 : " - ",
              canal3: d.data.canal3 || d.data.canal3 == 0 ? d.data.canal3 : " - ",
              canal4: d.data.canal4 || d.data.canal4 == 0 ? d.data.canal4 : " - ",
              rms1: d.data.rms1 || d.data.rms1 == 0 ? d.data.rms1 : " - ",
              rms2: d.data.rms2 || d.data.rms2 == 0 ? d.data.rms2 : " - ",
              rms3: d.data.rms3 || d.data.rms3 == 0 ? d.data.rms3 : " - ",
              rms4: d.data.rms4 || d.data.rms4 == 0 ? d.data.rms4 : " - ",
              corto1:
                d.data.corto1 || d.data.corto1 == 0
                  ? d.data.corto1 != 0
                    ? "Sí"
                    : "No"
                  : " - ",
              corto2:
                d.data.corto2 || d.data.corto2 == 0
                  ? d.data.corto2 != 0
                    ? "Sí"
                    : "No"
                  : " - ",
              corto3:
                d.data.corto3 || d.data.corto3 == 0
                  ? d.data.corto3 != 0
                    ? "Sí"
                    : "No"
                  : " - ",
              corto4:
                d.data.corto4 || d.data.corto4 == 0
                  ? d.data.corto4 != 0
                    ? "Sí"
                    : "No"
                  : " - ",
            };
            break;
          // Galga extensiométrica
          case Constants.ID_SENSOR_TYPES.GALGA.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              alimentacion:
                d.data.alimentacion || d.data.alimentacion == 0
                  ? d.data.alimentacion
                  : " - ",
              canal1: d.data.canal1 || d.data.canal1 == 0 ? d.data.canal1 : " - ",
              canal2: d.data.canal2 || d.data.canal2 == 0 ? d.data.canal2 : " - ",
              canal3: d.data.canal3 || d.data.canal3 == 0 ? d.data.canal3 : " - ",
              canal4: d.data.canal4 || d.data.canal4 == 0 ? d.data.canal4 : " - ",
            };
            break;
          // Meteorológico
          case Constants.ID_SENSOR_TYPES.METEO.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
              humedad: d.data.humedad || d.data.humedad == 0 ? d.data.humedad : " - ",
              lluvia: d.data.lluvia || d.data.lluvia == 0 ? d.data.lluvia : " - ",
              velocidadViento:
                d.data.velocidadViento || d.data.velocidadViento == 0
                  ? d.data.velocidadViento
                  : " - ",
              luminosidad:
                d.data.luminosidad || d.data.luminosidad == 0
                  ? d.data.luminosidad
                  : " - ",
              radiacion:
                d.data.radiacion || d.data.radiacion == 0 ? d.data.radiacion : " - ",
              presion: d.data.presion || d.data.presion == 0 ? d.data.presion : " - ",
              latitud: d.data.latitud || d.data.latitud == 0 ? d.data.latitud : " - ",
              longitud: d.data.longitud || d.data.longitud == 0 ? d.data.longitud : " - ",
            };
            break;
          // Iluminación led
          case Constants.ID_SENSOR_TYPES.LED.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              luz: d.data.luz || d.data.longitud == 0 ? d.data.luz : " - ",
            };
            break;
          // Detector de coches
          case Constants.ID_SENSOR_TYPES.CARDETECTOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              deteccion:
                d.data.deteccion || d.data.deteccion == 0
                  ? d.data.deteccion != 0
                    ? "Sí"
                    : "No"
                  : " - ",
              distancia:
                d.data.distancia || d.data.distancia == 0 ? d.data.distancia : " - ",
            };
            break;
          // Visibilidad
          case Constants.ID_SENSOR_TYPES.VISIBILIDAD.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              visibilidad:
                d.data.visibilidad || d.data.visibilidad == 0
                  ? d.data.visibilidad != 0
                    ? "Sí"
                    : "No"
                  : " - ",
            };
            break;
          // Velocidad
          case Constants.ID_SENSOR_TYPES.VELOCIDAD.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              velocidad:
                d.data.velocidad || d.data.velocidad == 0 ? d.data.velocidad : " - ",
            };
            break;
          // Luminosidad
          case Constants.ID_SENSOR_TYPES.LUMINOSIDAD.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              luminosidad:
                d.data.luminosidad || d.data.luminosidad == 0
                  ? d.data.luminosidad
                  : " - ",
            };
            break;
          // GPS
          case Constants.ID_SENSOR_TYPES.GPS.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              latitud:
                d.data.latitud || d.data.latitud == 0
                  ? (d.data.latitud * Math.pow(10, -7)).toFixed(7)
                  : " - ",
              longitud:
                d.data.longitud || d.data.longitud == 0
                  ? (d.data.longitud * Math.pow(10, -7)).toFixed(7)
                  : " - ",
            };
            break;
          // Temperatura analógica 4 canales
          case Constants.ID_SENSOR_TYPES.TEMP4NALOG.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura1:
                d.data.temperatura1 || d.data.temperatura1 == 0
                  ? d.data.temperatura1 / 10
                  : " - ",
              temperatura2:
                d.data.temperatura2 || d.data.temperatura2 == 0
                  ? d.data.temperatura2 / 10
                  : " - ",
              temperatura3:
                d.data.temperatura3 || d.data.temperatura3 == 0
                  ? d.data.temperatura3 / 10
                  : " - ",
              temperatura4:
                d.data.temperatura4 || d.data.temperatura4 == 0
                  ? d.data.temperatura4 / 10
                  : " - ",
            };
            break;
          // Piezómetro
          case Constants.ID_SENSOR_TYPES.PIEZOMETRO.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              presion: d.data.presion || d.data.presion == 0 ? d.data.presion : " - ",
            };
            break;
          // Cobertura
          case Constants.ID_SENSOR_TYPES.COBERTURA.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              cobertura:
                d.data.cobertura || d.data.cobertura == 0 ? d.data.cobertura : " - ",
            };
            break;
          // Transformador CT-HOBUT
          case Constants.ID_SENSOR_TYPES.CT_HOBUT.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              linea1: d.data.linea1 || d.data.linea1 == 0 ? d.data.linea1 : " - ",
              linea2: d.data.linea2 || d.data.linea2 == 0 ? d.data.linea2 : " - ",
              linea3: d.data.linea3 || d.data.linea3 == 0 ? d.data.linea3 : " - ",
              linea4: d.data.linea4 || d.data.linea4 == 0 ? d.data.linea4 : " - ",
              linea5: d.data.linea5 || d.data.linea5 == 0 ? d.data.linea5 : " - ",
              linea6: d.data.linea6 || d.data.linea6 == 0 ? d.data.linea6 : " - ",
              linea7: d.data.linea7 || d.data.linea7 == 0 ? d.data.linea7 : " - ",
              linea8: d.data.linea8 || d.data.linea8 == 0 ? d.data.linea8 : " - ",
              linea9: d.data.linea9 || d.data.linea9 == 0 ? d.data.linea9 : " - ",
            };
            break;

          case Constants.ID_SENSOR_TYPES.CTHOBUT3.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              linea1: d.data.linea1 || d.data.linea1 == 0 ? d.data.linea1 : " - ",
              linea2: d.data.linea2 || d.data.linea2 == 0 ? d.data.linea2 : " - ",
              linea3: d.data.linea3 || d.data.linea3 == 0 ? d.data.linea3 : " - ",
            };
            break;
          // PLUVIOMETRO WS2080
          case Constants.ID_SENSOR_TYPES.PLUVIOMETRO_WS2080.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              incremento:
                d.data.incremento || d.data.incremento == 0 ? d.data.incremento : " - ",
            };
            break;
          // ADCTEMP Atlantic Copper
          case Constants.ID_SENSOR_TYPES.ADCTEMP.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              tension: d.data.tension || d.data.tension == 0 ? d.data.tension : " - ",
              tensionCh1:
                d.data.tensionCh1 || d.data.tensionCh1 == 0 ? d.data.tensionCh1 : " - ",
              tensionCh2:
                d.data.tensionCh2 || d.data.tensionCh2 == 0 ? d.data.tensionCh2 : " - ",
              tensionCh3:
                d.data.tensionCh3 || d.data.tensionCh3 == 0 ? d.data.tensionCh3 : " - ",
              tensionCh4:
                d.data.tensionCh4 || d.data.tensionCh4 == 0 ? d.data.tensionCh4 : " - ",
              temp1: d.data.temp1 || d.data.temp1 == 0 ? d.data.temp1 : " - ",
              temp2: d.data.temp2 || d.data.temp2 == 0 ? d.data.temp2 : " - ",
              temp3: d.data.temp3 || d.data.temp3 == 0 ? d.data.temp3 : " - ",
              temp4: d.data.temp4 || d.data.temp4 == 0 ? d.data.temp4 : " - ",
              corto: d.data.corto || d.data.corto == 0 ? d.data.corto : " - ",
            };
            break;
          // Caudal GIE
          case Constants.ID_SENSOR_TYPES.FLOWGIE.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              caudal: d.data.caudal || d.data.caudal == 0 ? d.data.caudal : " - ",
            };
            break;
          // Calidad del agua GIE
          case Constants.ID_SENSOR_TYPES.WATERQUALITY.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              conductividad:
                d.data.conductividad || d.data.conductividad == 0
                  ? d.data.conductividad
                  : " - ",
              concentracionCl:
                d.data.concentracionCl || d.data.concentracionCl == 0
                  ? d.data.concentracionCl
                  : " - ",
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
              turbidez: d.data.turbidez || d.data.turbidez == 0 ? d.data.turbidez : " - ",
            };
            break;
          // Caudal de agua FLOWMETER
          case Constants.ID_SENSOR_TYPES.FLOWMETER.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              caudal: d.data.caudal || d.data.caudal == 0 ? d.data.caudal : " - ",
              incremento:
                d.data.incremento || d.data.incremento == 0 ? d.data.incremento : " - ",
            };
            break;
          // Sensor de alarma ALARMSENSOR
          case Constants.ID_SENSOR_TYPES.ALARMSENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              alarma: d.data.alarma || d.data.alarma == 0 ? d.data.alarma : " - ",
            };
            break;
          // Sensor de presion PRESSURESENSOR DPS310
          case Constants.ID_SENSOR_TYPES.PRESSURESENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              presion: d.data.presion || d.data.presion == 0 ? d.data.presion : " - ",
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
            };
            break;
          // VEGABAR-29
          case Constants.ID_SENSOR_TYPES.PRESSUREVEGABARSENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              presion_L1:
                d.data.presion_L1 || d.data.presion_L1 == 0 ? d.data.presion_L1 : " - ",
              presion_L2:
                d.data.presion_L2 || d.data.presion_L2 == 0 ? d.data.presion_L2 : " - ",
              presion_L3:
                d.data.presion_L3 || d.data.presion_L3 == 0 ? d.data.presion_L3 : " - ",
              presion_L4:
                d.data.presion_L4 || d.data.presion_L4 == 0 ? d.data.presion_L4 : " - ",
              presion_L5:
                d.data.presion_L5 || d.data.presion_L5 == 0 ? d.data.presion_L5 : " - ",
              presion_L6:
                d.data.presion_L6 || d.data.presion_L6 == 0 ? d.data.presion_L6 : " - ",
            };
            break;
          // Sensor de válvula VALVESENSOR USS2-00078
          case Constants.ID_SENSOR_TYPES.VALVESENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              estado: d.data.estado || d.data.estado == 0 ? d.data.estado : " - ",
            };
            break;

          // Sensor de temperatura Calex ExTEMP ( 0x1E)
          case Constants.ID_SENSOR_TYPES.TEMPCALEXTEMPSENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
            };
            break;


          // Sensor de temperatura y humedad Calex T3110EX ( 0x1F)
          case Constants.ID_SENSOR_TYPES.T3110EXSENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              temperatura:
                d.data.temperatura || d.data.temperatura == 0
                  ? d.data.temperatura
                  : " - ",
              humedad:
                d.data.humedad || d.data.humedad == 0
                  ? d.data.humedad
                  : " - ",
            };
            break;

          case Constants.ID_SENSOR_TYPES.ROCIOSENSOR.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              rocio:
                d.data.rocio || d.data.rocio == 0
                  ? d.data.rocio
                  : " - ",

            };
            break;

          case Constants.ID_SENSOR_TYPES.S451_CAUDALIMETRO.toString():
            newData = {
              uuid: d._id,
              raw_ts: this.$moment(String(d.raw_ts))
                .local()
                .format("DD-MM-YYYY HH:mm:ss.SSS"),
              consumo:
                d.data.consumo || d.data.consumo == 0
                  ? d.data.consumo
                  : " - ",

            };
            break;

          case Constants.ID_SENSOR_TYPES.SEN0604.toString():
            newData = {
              uuid: d._id,
              raw_ts: moment(String(d.raw_ts)).local().format("DD-MM-YYYY HH:mm:ss.SSS"),
              humedad:
                (d.data.humedad || d.data.humedad == 0) && d.data.humedad != "61440" && d.data.humedad != "6144"
                  ? d.data.humedad / 10
                  : " - ",
              temperatura:
                (d.data.temperatura || d.data.temperatura == 0) && d.data.temperatura != "61440" && d.data.temperatura != "6144"
                  ? d.data.temperatura / 10
                  : " - ",
              conductividad_electrica:
                (d.data.conductividad_electrica || d.data.conductividad_electrica == 0) && d.data.conductividad_electrica != "61440"
                  ? d.data.conductividad_electrica
                  : " - ",
              ph:
                (d.data.ph || d.data.ph == 0) && d.data.ph != "61440" && d.data.ph != "6144"
                  ? d.data.ph / 10
                  : " - ",

            };
            break;

          case Constants.ID_SENSOR_TYPES.SEN0605.toString():
            newData = {
              uuid: d._id,
              raw_ts: moment(String(d.raw_ts)).local().format("DD-MM-YYYY HH:mm:ss.SSS"),
              nitrogeno:
                (d.data.nitrogeno || d.data.nitrogeno == 0) && d.data.nitrogeno != "61440" && d.data.nitrogeno != "6144"
                  ? d.data.nitrogeno
                  : " - ",
              fosforo:
                (d.data.fosforo || d.data.fosforo == 0) && d.data.fosforo != "61440" && d.data.fosforo != "6144"
                  ? d.data.fosforo
                  : " - ",
              potasio:
                (d.data.potasio || d.data.potasio == 0) && d.data.potasio != "61440"
                  ? d.data.potasio
                  : " - ",


            };
            break;

          default:
            throw new Error("Error - SensorMeasures.vue - id_sensor_type unknown");
        }
        if (newData != null) {
          //Push the data to the array
          if (exportData) {
            this.exportRows.push(newData);
          } else {
            this.rows.push(newData);
          }
        }
      }
    },
  },
};
</script>
